import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    bankacconly() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/bankcashacc/bankaccount");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`arinv/detail/${obj.arinvKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailcollection(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`arinv/detailcollection/${obj.arinvKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailsalesorder(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/salesorder/detail/${obj.salesHdrKey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    detailsettle(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`arinv/detailsettle/${obj.arinvKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    downloadtemplate() {
        axios({
            url: `/download/ar-upload`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'EkosSystem-AR-upload-template.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },    
    exportcsv(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup',  'posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/arinv/exportcsv${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'e-faktur-import.csv');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                });
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'pack_name','posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled', 'deffered'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/arinv/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'arinv.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    findcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`coa/findcoa/${obj.kodeacc}/${obj.tahun}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("arinv", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian','collector', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'pack_name', 'posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled', 'sisterinv', 'deffered'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
            }
                const url = `/arinv${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    collectorexport(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'pack_name','posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/arinv/collectorexport${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'arinv_collection_view.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },    
    collectorview(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian','collector', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'pack_name', 'posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled', 'sisterinv'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
            }
                const url = `arinv/collectorview${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    collectorprintlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'pack_name','posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/arinv/collectorprintlist/${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    collectorprintlistbycustomer(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'pack_name','posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/arinv/collectorprintlistbycustomer/${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    outstandstatus() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arinv/outstandstatus");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arinv/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    paymentform() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arinv/paymentform");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arinv/postgroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`arinv/posting/${obj.arinvKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`arinv/unposting/${obj.arinvKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postall(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`arinv/postingall`,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unpostall(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`arinv/unpostingall`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.arinvKey);
                url = `/arinv/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.arinvKey);
                url = `/arinv/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printbillcsv(arrInv) {
        return new Promise(async (resolve, reject) => {
            try {
                axios({
                    url: `/arinv/printbillcsv?arrInv=${encodeURIComponent(JSON.stringify(arrInv))}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'e-faktur-import.csv');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                });
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printbills(arrInv) {
        return new Promise(async (resolve, reject) => {
            try {                
                const { data } = await axios.get(`/arinv/printbills?arrInv=${encodeURIComponent(JSON.stringify(arrInv))}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printkwitansiupdate(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`arinv/printkwitansiupdate/${obj.arinvKey}`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    printkwitansi(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.arinvKey);
                url = `/arinv/printkwitansi`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printkwitansis(arrInv) {
        return new Promise(async (resolve, reject) => {
            try {                
                const { data } = await axios.get(`/arinv/printkwitansis?arrInv=${encodeURIComponent(JSON.stringify(arrInv))}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    printlist(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'pack_name','posting', 'invmanual', 'ostStatuskey', 'custcode', 'canceled'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/arinv/printlist/${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`arinv/${obj.arinvKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesAccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arinv/salesaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesAccountNoCompany() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arinv/salesaccount-nocompany");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    salesOrder(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`/salesorder/detail/${obj.salesHdrKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    upload(fileXlsx,obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', fileXlsx, fileXlsx.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {

                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                        fd.append(key, obj[key]);
                    // }
                }

                const resp = await axios.post("arinv/uploadinv", fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                resolve(resp);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unupload(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`arinv/unuploadinv`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    updatecollect(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const { ostStatuskey, colleNote, collector } = obj;
                // const { data } = await axios.put(`arinv/updatecollect/${obj.arinvKey}`, { ostStatuskey, colleNote, collector });
                const { data } = await axios.put(`arinv/updatecollect/${obj.arinvKey}`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    updateNoVal(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`arinv/updatenoval/${obj.arinvKey}`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    updateLineNoVal(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`arinv/updatelinenoval/${obj.arinvdtKey}`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
};